import { FEEDS_ROUTES } from '../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'

import feedsTypes from '../constants/feedsTypes'
// import forms_types from '../constants/formsTypes'
import { axios } from '../services'

import { try_force_logoff } from './authActions'

const reset_feed_errors = () => {
  return {
    type: feedsTypes.reset_errors
  }
}

const set_current_feed = ( feed ) => {
  return {
    type: "SET_CURRENT_FEED",
    payload: feed
  }
}

const show_sidebar_feed_actions = () => {
  return {
    type: "SHOW_SIDEBAR_FEED_ACTIONS"
  }
}

const hide_sidebar_feed_actions = () => {
  return {
    type: "HIDE_SIDEBAR_FEED_ACTIONS"
  }
}

// GET Project
const get_project_request = () => {
  return {
    type: feedsTypes.get.request
  }
}

const get_project_refresh_request = () => {
  return {
    type: feedsTypes.get.refresh_request
  }
}


const get_project_success = (response) => {
  return {
    type: feedsTypes.get.success,
    payload: response.data.feed
  }
}

const get_project_minimal_success = (response) => {
  return {
    type: feedsTypes.get.success_minimal,
    payload: response.data
  }
}

const get_project_failure = (messages) => {
  return {
    type: feedsTypes.get.failure,
    payload: messages
  }
}

const reset_feed_redirect = () => {
  return {
    type: feedsTypes.get.reset_redirect
  }
}

const get_project = (feed_id, page = 1, refresh=false, show="standard") => {
  return function(dispatch) {
    // Before Request
    if (refresh) {
      dispatch(get_project_refresh_request())
    } else {
      dispatch(get_project_request())
    }

    // Request
    axios.get(
      formatRoute(FEEDS_ROUTES.get, {id: feed_id}),
      {
        params: {
          page: page,
          per_page: 10,
          show: show
        }
      }
    ).then( response => {
      // success
      if ( ! refresh ) {
        dispatch( reset_feed_redirect() )
      }
      if ( show === "minimal" ) {
        dispatch( get_project_minimal_success(response) )
      } else {
        dispatch( get_project_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [error]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( get_project_failure(errors) )
    })
  }
}

// Create Optimized Feed
const create_optimized_request = () => {
  return {
    type: feedsTypes.create_optimized.request
  }
}

const create_optimized_success = (response) => {
  return {
    type: feedsTypes.create_optimized.success,
    payload: response.data.feed
  }
}

const create_optimized_failure = (messages) => {
  return {
    type: feedsTypes.create_optimized.failure,
    payload: messages
  }
}

const create_optimized_feed = ( feed_id, feedData ) => {
  return function(dispatch) {
    // Before Request
    dispatch(create_optimized_request())

    // Request
    const { name } = feedData
    axios.post(
      formatRoute(FEEDS_ROUTES.create_optimized, {id: feed_id}),
      {
        feed: {
          name: name
        }
      }
    ).then( response => {
      // success
      dispatch( create_optimized_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating optimized feed."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( create_optimized_failure(errors) )
    })
  }
}


// Create FEED
const create_project_request = () => {
  return {
    type: feedsTypes.create.request
  }
}

const create_project_success = (response) => {
  return {
    type: feedsTypes.create.success,
    payload: response.data.feed
  }
}

const create_project_failure = (messages) => {
  return {
    type: feedsTypes.create.failure,
    payload: messages
  }
}

const create_project= (feedData) => {
  return function(dispatch) {
    // Before Request
    dispatch(create_project_request())

    // Request
    // let { url, name, http_user, http_pass } = feedData
    console.log("feedData")
    console.log(feedData)
    axios.post(
      FEEDS_ROUTES.create,
      feedData
      // {
      //   // feed: {
      //   //   url: url,
      //   //   name: name,
      //   //   http_user: http_user,
      //   //   http_pass: http_pass
      //   // }
      //   feed: feedData
      // }
    ).then( response => {
      // success
      dispatch( create_project_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating feed."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( create_project_failure(errors) )
    })
  }
}

// Get FEEDS
const feeds_index_request = () => {
  return {
    type: feedsTypes.index.request
  }
}

const feeds_index_success = (response) => {
  return {
    type: feedsTypes.index.success,
    payload: response.data
  }
}

const feeds_index_failure = (messages) => {
  return {
    type: feedsTypes.index.failure,
    payload: messages
  }
}

const feeds_index = (page) => {
  return function (dispatch) {
    // Before Request
    dispatch(feeds_index_request())

    // Request
    axios.get(
      FEEDS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: 10
        }
      }
    ).then( response => {
      // success
      dispatch( feeds_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching feeds."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( feeds_index_failure(errors))
    })
  }
}

export {
  reset_feed_errors,
  set_current_feed,
  show_sidebar_feed_actions,
  hide_sidebar_feed_actions,
  feeds_index,
  get_project,
  create_project,
  create_optimized_feed
}

export * from './feeds'



// WEBPACK FOOTER //
// ./src/js/actions/feedsActions.js